import { BaseService, type ResponseMessage, type SearchRequest } from "@kiddocare-platform/portal-common/base";
import type { CertificateField, Instance } from "@kiddocare-platform/portal-common/certifications";

export class CertificationsExecutionService extends BaseService {

  public async GetByInstance(ticket: string): Promise<ResponseMessage<{ instance: Instance, certificateFields: Array<CertificateField> }>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/execution/instances/getByInstance/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetByInstance", error.stack, JSON.stringify(error));
      throw error.response?.data ? error.response.data : error;
    }
  }

  public async CreateDemand(data: {
    idAccountPatient: bigint | number;
    idAccountPediatrician: bigint | number;
    idCertificate: bigint | number;
    notes?: string;
    values: { name: string | undefined; value: any }[];
  }): Promise<ResponseMessage<Instance>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/createDemand`, data);
      return response.data;
    } catch (error: any) {
      this.log.error("CreateDemand", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async Delete(ticket: string): Promise<any> {
    try {
      const response = await this.AxiosInstance.delete(`/parent/execution/instances/delete/${ticket}`);
      return response.data;
    }
    catch (error: any) {
      this.log.error("Delete", error.stack, JSON.stringify(error));
      throw error.response.data ? error.response.data : error;
    }
  }

  public async Search(query: SearchRequest): Promise<ResponseMessage<Array<Instance>>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/execution/instances/search`, query);
      return response.data;
    } catch (error: any) {
      this.log.error("Search", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}